import I18n from 'i18n-js';

import dayjs from 'dayjs';

import en from './en';
import nl from './nl';

import type { Locales } from './types';

require('dayjs/locale/nl');

I18n.translations = {
  en,
  nl,
};

const supportedLanguageTags = ['en', 'nl'];

const translateLanguageTag: { [key: string]: string } = {
  en: 'en',
  nl: 'nl',
};

// TODO: Check the best available language for the browser from the supportedLanguageTags, if not the default will be 'nl'
export const setLanguageToI18n = (): void => {
  const languageTag =
    process.env.NODE_ENV === 'development'
      ? supportedLanguageTags[0]
      : supportedLanguageTags[1];

  I18n.locale = translateLanguageTag[languageTag];

  dayjs.locale(languageTag);

  // set default app locale to be 'en'
  I18n.defaultLocale = 'en';
  // if locale string is not found for a given locale (e.g. pt_BR), the fallback will be
  // to use the default locale ('en')
  I18n.fallbacks = true;
};

setLanguageToI18n();

export const createLocale = <T extends keyof Locales>(
  entry: T,
): ((
  key: Extract<keyof Locales[T], string>,
  config?: Omit<I18n.TranslateOptions, 'scope'>,
) => string) => {
  const defaultConfig = { scope: entry };
  return (key, config) => {
    const selectedConfig = config
      ? { ...config, ...defaultConfig }
      : defaultConfig;
    return I18n.t(key, selectedConfig);
  };
};
